import React from 'react'
import * as styles from './welcome.module.css'
import Modal from '../UI/modal'
import { useState } from 'react'
import { Link } from 'gatsby'

const Welcome = () => {
  const [showModal, setShowModal] = useState(false)
  const modalHandler = () => {
    setShowModal((prev) => setShowModal(!prev))
  }
  return (
    <section>
      <div className={styles.promo}>
        <div className={styles.promoInner}>
          <span>
            Красивые и эффективные веб-сайты, соответствующие Вашим требованиям
          </span>
          <h1>Frudee Web Studio</h1>
          <span>
            Наша команда дизайнеров и разработчиков создает стильные и
            прибыльные интернет-решения для Вас и Вашего бизнеса. Сотрудничать с
            нами - проще простого!
          </span>
          <div className={styles.buttonGroup}>
            <button onClick={modalHandler}>Заказать веб-сайт</button>
            <Link to="#about">О нас</Link>
          </div>
        </div>
      </div>
      <Modal onClose={modalHandler} show={showModal} />
    </section>
  )
}

export default Welcome
